import * as UI from '@brewlogix/blx-ui'

import { CompositeProduct, Location } from 'src/types/schema/graphql'
import Image from 'next/image'
import getDefaultIconByProduct from 'src/util/helpers/getDefaultIconByProduct'

import React from 'react'
import Link from 'next/link'
import classNames from 'classnames'

interface IBrewCard {
    item: CompositeProduct | Location
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
    children?: React.ReactNode
    link?: {
        href: string
        label: string
    }
    customClasses?: string
}

const BrewCard: React.FC<IBrewCard> = ({ item, onClick, children, link, customClasses }) => {
    const itemAsset = item?.assets?.length > 0 ? item?.assets[0] : item?.brand?.assets[0] || null
    const defaultIcon = getDefaultIconByProduct(item as CompositeProduct)
    const imageChildren = (
        <div className='brew-card__image flex items-center justify-center'>
            {itemAsset ? (
                <div className='overflow-hidden rounded-lg'>
                    <UI.Media
                        asset={itemAsset}
                        customWrapperClasses='aspect-square w-full'
                        width={400}
                        height={400}
                        alt={`Logo Image for ${item?.title}`}
                    />
                </div>
            ) : (
                <div className='flex items-center justify-center rounded-lg'>
                    <Image
                        src={defaultIcon}
                        alt={`Default ${item?.__typename} Icon`}
                        width={400}
                        height={400}
                    />
                </div>
            )}
        </div>
    )
    return (
        <article
            onClick={onClick}
            className={classNames(
                'card card--default bdb-brewcard group h-full w-full cursor-pointer duration-200 ease-in-out hover:border-transparent hover:bg-gray-50',
                customClasses
            )}
            data-cy='brew-card'
        >
            <div className='brew-card__header w-full'>
                {link?.href ? (
                    <Link href={link.href} passHref>
                        <a aria-label={link.label} className='inline-block w-full'>
                            {imageChildren}
                        </a>
                    </Link>
                ) : (
                    imageChildren
                )}
                {children}
            </div>
        </article>
    )
}

export default BrewCard
